import App from './App.svelte';

export default function(target, props) {

	if(!target || !props) {
		throw new Error('App init failed. Missing target or props');
	}

	new App({
		target,
		props
	});
}
